import Sidebar from "../Common/Sidebar";
import React, { useState } from "react";
import ShowDocument from "./ShowDocument";
import { Dialog } from "primereact/dialog";
import ResearchPopup from "./ResearchPopup";
import SupportChatComponent from "./SupportChatComponent";
import CallChatComponent from "./CallChatComponent";

export default function ChatLandingPage() {
  const [showDocument, setShowDocument] = useState(false);
  const [showResearchPopup, setShowResearchPopup] = useState(false);
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const [showHistory, setShowHistory] = useState(false);
  const [activeMode, setActiveMode] = useState<"support" | "call">("support");

  const onOpenDocumentClick = () => setShowDocument(true);
  const onDocumentCloseClick = () => setShowDocument(false);
  const onResearchBoxClick = () => setShowResearchPopup(true);
  const onSidebarValueChanged = (value: any) => setShowWideSidebar(value);
  const onhistoryValueChanged = (value: any) => setShowHistory(value);

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar
        pagename="chat"
        onSidebarValueChanged={onSidebarValueChanged}
        showHistory={showHistory}
        onShowHistoryChanged={onhistoryValueChanged}
      />

      <div className="flex-grow-1 d-flex flex-column bg-light py-5 px-5">
        <div
          className={`${
            showWideSidebar
              ? "main-content-large-width"
              : "main-content-small-width"
          }`}
        >
          <div
            className={`${
              showHistory
                ? "main-historycontent-large-width"
                : "main-historycontent-small-width"
            }`}
          >
            {/* Conditional Component Rendering - Remove mode toggle buttons from here */}
            {activeMode === "support" ? (
              <SupportChatComponent
                showWideSidebar={showWideSidebar}
                showHistory={showHistory}
                onOpenDocumentClick={onOpenDocumentClick}
                activeMode={activeMode}
                setActiveMode={setActiveMode}
              />
            ) : (
              <CallChatComponent
                showWideSidebar={showWideSidebar}
                showHistory={showHistory}
                onOpenDocumentClick={onOpenDocumentClick}
                activeMode={activeMode}
                setActiveMode={setActiveMode}
              />
            )}

            {showDocument && (
              <ShowDocument onDocumentCloseClick={onDocumentCloseClick} />
            )}

            <Dialog
              header="Research"
              visible={showResearchPopup}
              onHide={() => setShowResearchPopup(false)}
              style={{ width: "50vw" }}
              className="researchpopup text-14"
            >
              <ResearchPopup onHide={() => setShowResearchPopup(false)} />
            </Dialog>
          </div>
        </div>
      </div>
    </div>
  );
}
